/* unplugin-vue-components disabled */import { render } from "./AIQuizSubChapterSelect.vue?vue&type=template&id=6b7dbcae&scoped=true&ts=true"
import script from "./AIQuizSubChapterSelect.vue?vue&type=script&lang=ts"
export * from "./AIQuizSubChapterSelect.vue?vue&type=script&lang=ts"

import "./AIQuizSubChapterSelect.vue?vue&type=style&index=0&id=6b7dbcae&lang=scss&scoped=true"
import "./AIQuizSubChapterSelect.vue?vue&type=style&index=1&id=6b7dbcae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7dbcae"]])

export default __exports__